import axios from "axios";
import { ManageApis } from "../AppServices/ManageApi";
import { getLocalStorage } from "./Utils";
import { getMenuApiUrl } from "./MenuVersionHelper";

export async function handleExtraction(
  base64,
  type,
  selectedMenu,
  selectedSide = "",
  menuList,
  files,
) {
  //console.log('current selected menu ----->', selectedMenu)
  //console.log('current menu list ----->', menuList)
  const findMenuId = menuList.find(
    (menuItem) => menuItem.menuName === selectedMenu
  );
  const reqstData = {
    image: base64,
    userId: getLocalStorage("clientId"),
    menuId: `${findMenuId?.id}`,
    AccountsId: getLocalStorage("accountsId"),
  };
  let result = "";
  // pan reader
  if (selectedMenu === "PANREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis("post", `${global.panreader}/PanCard`, reqstData);

    // response = result
  }
  // Aadhar Masking
  else if (selectedMenu === "AADHARMASKING") {
    // var imageType = params.match(/^data:image\/(\w+);base64,/)[1];
    const reqstData1 = {
      userId: getLocalStorage("clientId"),
      aadhar_image: base64,
      image_format: type,
      image_uuid: "123",
      pdf_out: false,
      detection_based_masking: true,
      menuId: `${findMenuId?.id}`,
      AccountsId: getLocalStorage("accountsId"),
    };

    try {
      // let
      result = await ManageApis(
        "post",
        `${global.aadharmasking}/AadharMasking`,
        reqstData1,
      );
      if (result) {
        // response = result
      }
    } catch (error) {
      // //console.log(error)
    }
  }
  // DD Reader
  else if (selectedMenu === "DDREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis("post", `${global.ddreader}/DD`, reqstData);

    // response = result
  }
  // Cheque Reader
  else if (selectedMenu === "CHEQUEREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis(
      "post",
      `${global.chequereader}/Cheque`,
      reqstData,
    );

    // response = result
  }
  // MEXICANVOTERIDOCR
  else if (selectedMenu === "MEXICANVOTERIDOCR") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };
    // let
    result =
      selectedSide === "Front"
        ? await ManageApis(
            "post",
            `${global.mexicanIdreader}/mexicanVoterIdFrontSide`,
            reqstData,
          )
        : await ManageApis(
            "post",
            `${global.mexicanIdreader}/mexicanVoterIdBackSide`,
            reqstData,
          );

    // response = result
  }
  // Passport Reader
  else if (selectedMenu === "PASSPORTREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result =
      selectedSide === "Front"
        ? await ManageApis(
            "post",
            `${global.passport}/PassportFrontSide`,
            reqstData,
          )
        : await ManageApis(
            "post",
            `${global.passport}/PassportBackSide`,
            reqstData,
          );

    // response = result
  }
  // Aadhar Reader
  else if (selectedMenu === "AADHARREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result =
      selectedSide === "Front"
        ? await ManageApis(
            "post",
            `${global.aadharreader}/AadharCardFrontSide`,
            reqstData,
          )
        : await ManageApis(
            "post",
            `${global.aadharreader}/AadharCardBackSide`,
            reqstData,
          );

    // response = result
  }
  // VoterId Reader
  else if (selectedMenu === "VOTERIDREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };
    // let
    result =
      selectedSide === "Front"
        ? await ManageApis(
            "post",
            `${global.voterid}/VoterIdFrontSide`,
            reqstData,
          )
        : await ManageApis(
            "post",
            `${global.voterid}/VoterIdBackSide`,
            reqstData,
          );

    // response = result
  }
  // EmiratesId Reader
  else if (selectedMenu === "EMIRATESIDREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result =
      selectedSide === "Front"
        ? await ManageApis(
            "post",
            `${global.emiratesid}/EmiratesIdFrontSide`,
            reqstData,
          )
        : await ManageApis(
            "post",
            `${global.emiratesid}/EmiratesIdBackSide`,
            reqstData,
          );

    // response = result
  }
  // QatarID Reader
  else if (selectedMenu === "QATARIDREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };
    // let
    result =
      selectedSide === "Front"
        ? await ManageApis(
            "post",
            `${global.voterid}/QatarIdFrontSide`,
            reqstData,
          )
        : await ManageApis(
            "post",
            `${global.voterid}/QatarIdBackSide`,
            reqstData,
          );

    // response = result
  }
  // OVDClassification
  else if (selectedMenu === "OVDCLASSIFICATION") {
    const reqstData1 = {
      userId: getLocalStorage("clientId"),
      image: base64,
      imageType: base64.includes("image") ? "png" : "pdf",
      menuId: `${findMenuId?.id}`,
      AccountsId: getLocalStorage("accountsId"),
    };

    // let
    result = await ManageApis("post", `${global.ovdclasification}`, reqstData1);

    // response = result
  }
  // mexicaninvoiceParser
  else if (selectedMenu === "MEXICANINVOICEPARSER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis(
      "post",
      `${global.mexicanInvoiceparser}`,
      reqstData,
    );

    // response = result
  }
  // qrreader
  else if (selectedMenu === "qrreader") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis("post", `${global.qrReader}/QRCode`, reqstData);

    // response = result
  }
  // malasyan driving liscense
  else if (selectedMenu === "MALAYSIANDRIVINGLICENSE") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis(
      "post",
      `${global.malaysianDringLicense}`,
      reqstData,
    );

    // response = result
  } else if (selectedMenu === "UAEDRIVINGLICENSE") {
    result = await ManageApis("post", `${global.UAEDringLicense}`, reqstData);
  }
  // malasyan driving liscense
  else if (selectedMenu === "MALAYSIANIDREADER") {
    // const reqstData = {
    //   image: base64,
    //   userId: getLocalStorage("clientId"),
    //   menuId: `${findMenuId?.id}`,
    // };

    // let
    result = await ManageApis("post", `${global.malaysianID}`, reqstData);

    // response = result
  } else if (selectedMenu === "IMAGETOJSON") {
    result = await ManageApis("post", `${global.invoiceparser}`, {
      ...reqstData,
      extension: type,
    });
  } else if (selectedMenu === "CHECKSHEETPROCESSING") {
    result = await ManageApis("post", `${global.checksheetProcessor}`, {
      ...reqstData,
      extension: type,
    });
  } else if (selectedMenu === "EVISAEXTRACTION") {
    result = await ManageApis("post", `${global.eVisaExtraction}`, {
      ...reqstData,
    });
  } else if (selectedMenu === "FEDERALBANKAOF") {
    let formData = new FormData();
    formData.append("file", files);
    result = await ManageApis("post", `${global.aofUpload}`, formData, {
      UserId: getLocalStorage("clientId"),
      AccountId: getLocalStorage("accountsId"),
    });
  } else if (selectedMenu === "AOFEXTRACTION") {
    result = await ManageApis("post", `${global.aofExtraction}`, {
      ...reqstData,
      extension: type,
    });
  } else if (selectedMenu === "TRANSCOMPDFEXTRATION") {
    result = await ManageApis("post", `${global.getTranscomPdfExtration}`, {
      image: base64,
      userId: getLocalStorage("clientId"),
      menuId: `${findMenuId?.id}`,
      accountsId: getLocalStorage("accountsId"),
      extension: type,
    });
  } else if (selectedMenu === "CANADIANDL") {
    result = await ManageApis("post", `${global.canadianDL}`, {
      image: base64,
      recordId: getLocalStorage("clientId") || "",
    });
  } else if (selectedMenu === "DYNAMICOVDEXTRACTOR") {
    result = await ManageApis("post", `${global.dynamicOVD}`, {
      ID_Image: base64,
      recordId: getLocalStorage("clientId") || "",
    });
  } else if (selectedMenu === "PRESCRIPTIONOCR") {
    const apiUrl = getMenuApiUrl("PRESCRIPTIONOCR", global.prescriptionOCR);
    result = await ManageApis("post", apiUrl, {
      input_base64: base64,
      uuid: getLocalStorage("clientId") || "",
    });
  } else if (selectedMenu === "MEDICALREPORT") {
    const trimmedBase64 = base64?.split(",")[1].trim();
    result = await ManageApis("post", `${global.MEDICALREPORT}`, {
      pdf_data: trimmedBase64,
      file_name: files?.name || "",
    });
  } else if (selectedMenu === "UAEVISAOCR") {
    result = await ManageApis("post", `${global.UAEVISAOCR}`, {
      image: base64,
      recordId: getLocalStorage("clientId") || "",
    });
  }
  return result;
}
